<template>
<div class="chapter">
<div class="inner_page">
<h2 class="Minion-Bold">Contents</h2>
<p class="con-in1"> </p>
<p class="con-in1"> </p>
<p class="con-in1"> </p>
<p class="con-in1"><a href="#/Introduction"><span style="color:#000">Introduction</span></a></p>
<p class="con-in1"> </p>
<p class="con-in1"><a href="#/Acknowledgments"><span style="color:#000">Acknowledgments</span></a></p>
<p class="con-in1"> </p>
<p class="con-in1"><a href="#/key"><span style="color:#000">Key to Symbols</span></a></p>
<p class="con-in1"> </p>
<p class="con-in1"><a href="#/chapter1"><span style="color:#000">Reviews</span></a></p>
<p class="con-in1"> </p>
<p class="con-in1"><span href="#/chapter27" title="Link target outside of Sample"><span style="color:#000">The Best Films of 2011</span></span></p>
<p class="con-in1"> </p>
<p class="con-in1"><span href="#/chapter27#b1" title="Link target outside of Sample"><span style="color:#000">The Best Documentaries of 2011</span></span></p>
<p class="con-in1"> </p>
<p class="con-in1"><span href="#/chapter28" title="Link target outside of Sample"><span style="color:#000">Interviews</span></span></p>
<p class="con-in2"><span href="#/chapter28#b2" title="Link target outside of Sample"><span style="color:#000">Asghar Farhadi <em>(A Separation)</em></span></span></p>
<p class="con-in2"><span href="#/chapter28#b3" title="Link target outside of Sample"><span style="color:#000">Tilda Swinton <em>(We Need to Talk About Kevin)</em></span></span></p>
<p class="con-in2"><span href="#/chapter28#b4" title="Link target outside of Sample"><span style="color:#000">Quvenzhane Wallis <em>(Beasts of the Southern Wild)</em></span></span></p>
<p class="con-in1"> </p>
<p class="con-in1"><span href="#/chapter29" title="Link target outside of Sample"><span style="color:#000">Ebert’s Journal</span></span></p>
<p class="con-in2"><span href="#/chapter29#b5" title="Link target outside of Sample"><span style="color:#000">Sarah Palin Documentary</span></span></p>
<p class="con-in2"><span href="#/chapter29#b6" title="Link target outside of Sample"><span style="color:#000">The Enigma of Political Prayer</span></span></p>
<p class="con-in2"><span href="#/chapter29#b7" title="Link target outside of Sample"><span style="color:#000">A   Shimmering Mirage</span></span></p>
<p class="con-in2"><span href="#/chapter29#b8" title="Link target outside of Sample"><span style="color:#000">Knocked Up At the Movies</span></span></p>
<p class="con-in2"><span href="#/chapter29#b9" title="Link target outside of Sample"><span style="color:#000">The Sudden Death of Film</span></span></p>
<p class="con-in2"><span href="#/chapter29#b10" title="Link target outside of Sample"><span style="color:#000">Heteronormative Vampires</span></span></p>
<p class="con-in2"><span href="#/chapter29#b11" title="Link target outside of Sample"><span style="color:#000">Dissecting Declining Box Office Revenue</span></span></p>
<p class="con-in2"><span href="#/chapter29#b12" title="Link target outside of Sample"><span style="color:#000">Think of Me as the Butler, Carson</span></span></p>
<p class="con-in2"><span href="#/chapter29#b13" title="Link target outside of Sample"><span style="color:#000">The Oscar Losers: They Wuz Robbed</span></span></p>
<p class="con-in2"><span href="#/chapter29#b14" title="Link target outside of Sample"><span style="color:#000">Indie Spirit Awards Joined <em>The Artist</em> Bandwagon</span></span></p>
<p class="con-in2"><span href="#/chapter29#b15" title="Link target outside of Sample"><span style="color:#000">Hey, Kids! Anybody Here Not Heard the F-Word?</span></span></p>
<p class="con-in2"><span href="#/chapter29#b16" title="Link target outside of Sample"><span style="color:#000"><em>The Raid</em> and Why I Hated It</span></span></p>
<p class="con-in2"><span href="#/chapter29#b17" title="Link target outside of Sample"><span style="color:#000">I Remember You</span></span></p>
<p class="con-in2"><span href="#/chapter29#b18" title="Link target outside of Sample"><span style="color:#000">The Perfect Audience</span></span></p>
<p class="con-in2"><span href="#/chapter29#b19" title="Link target outside of Sample"><span style="color:#000">Movies Don’t Stream Themselves</span></span></p>
<p class="con-in2"><span href="#/chapter29#b20" title="Link target outside of Sample"><span style="color:#000">A Few Calm Words About The List</span></span></p>
<p class="con-in1"> </p>
<p class="con-in1"><span href="#/chapter30" title="Link target outside of Sample"><span style="color:#000">In Memoriam</span></span></p>
<p class="con-in2"><span href="#/chapter30#b21" title="Link target outside of Sample"><span style="color:#000">Andrew Sarris</span></span></p>
<p class="con-in1"> </p>
<p class="con-in1"><span href="#/chapter31" title="Link target outside of Sample"><span style="color:#000">Film Festival</span></span></p>
<p class="con-in2"><span href="#/chapter31#b22" title="Link target outside of Sample"><span style="color:#000">Toronto International Film Festival</span></span></p>
<p class="con-in1"> </p>
<p class="con-in1"><span href="#/chapter32" title="Link target outside of Sample"><span style="color:#000">Ebert’s Little Movie Glossary</span></span></p>
<p class="con-in1"> </p>
<p class="con-in1"><span href="#/index" title="Link target outside of Sample"><span style="color:#000">Index</span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// content.vue?a155f5c6